import React, { useCallback, useContext } from 'react'
import { getTextAroundWord } from 'modules/community/utils/get-text-around-word'

export interface HighlightSearchContextType {
  highlightKeyword: string
  wrapWithHighlight: (text: string, truncateLength: number) => string
}

const HighlightSearchContext = React.createContext<HighlightSearchContextType | undefined>(
  undefined,
)
export const useHighlightSearchContext = (): HighlightSearchContextType | undefined =>
  useContext(HighlightSearchContext)

interface HighlightSearchProviderProps {
  highlightKeyword: string
  children: React.ReactNode
}

export const HighlightSearchProvider: React.FC<HighlightSearchProviderProps> = ({
  highlightKeyword,
  children,
}) => {
  const wrapWithHighlight = useCallback(
    (text: string, truncateLength: number) => {
      return highlightKeyword ? getTextAroundWord(text, truncateLength, highlightKeyword) : text
    },
    [highlightKeyword],
  )

  return (
    <HighlightSearchContext.Provider value={{ highlightKeyword, wrapWithHighlight }}>
      {children}
    </HighlightSearchContext.Provider>
  )
}
